import i18n from '../i18n';
import type { Rule } from 'antd/es/form';
import type { ReducedOrganization } from '../Types/interfaces';

const checkCompanyNameExists = async (
  name: string,
  organizations: ReducedOrganization[]
): Promise<boolean> => {
  try {
    const exists = organizations.some(
      (organization) => organization.name === name
    );
    return exists;
  } catch (error) {
    console.error(i18n.t('validator.companyNameError'), error);
    return false;
  }
};

export const validateCompanyName = async (
  _: Rule,
  value: string,
  organizations: ReducedOrganization[]
): Promise<void> => {
  if (!value) {
    return Promise.resolve();
  }
  const exists = await checkCompanyNameExists(value, organizations);
  if (exists) {
    return Promise.reject(new Error(i18n.t('validator.companyNameUsed')));
  }
  return Promise.resolve();
};

export const validateAtLeastOneStudent =
  (otherFieldName: string, t: any) =>
  ({ getFieldValue }: any) => ({
    validator(_: any, value: any) {
      const otherValue = getFieldValue(otherFieldName) || 0;
      const currentValue = value || 0;

      if (currentValue === 0 && otherValue === 0) {
        return Promise.reject(
          new Error(t('orgRegComp.atLeastOneStudentNeeded'))
        );
      }
      return Promise.resolve();
    },
  });
